export const state = {
    layout_type: 'horizontal',
    layout_width: 'fluid',
    left_sidebar_type: 'dark',
    top_bar: 'dark',
    loader: false
}

export const mutations = {
    CHANGE_LAYOUT(state, layout_type) {
        state.layout_type = layout_type;
    },
    CHANGE_LAYOUT_WIDTH(state, layout_width) {
        state.layout_width = layout_width;
    },
    CHANGE_LEFT_SIDEBAR_TYPE(state, left_sidebar_type) {
        state.left_sidebar_type = left_sidebar_type;
    },
    CHANGE_TOPBAR(state, top_bar) {
        state.top_bar = top_bar;
    },
    LOADER(state, loader) {
        state.loader = loader
    }
}

export const actions = {
    changeLayoutType({commit}, {layout_type}) {
        commit('CHANGE_LAYOUT', layout_type);
    },

    changeLayoutWidth({commit}, {layout_width}) {
        commit('CHANGE_LAYOUT_WIDTH', layout_width)
    },

    changeLeftSidebarType({commit}, {left_sidebar_type}) {
        commit('CHANGE_LEFT_SIDEBAR_TYPE', left_sidebar_type)
    },

    changeTopbar({commit}, {top_bar}) {
        commit('CHANGE_top_bar', top_bar)
    },

    changeLoaderValue({commit}, {loader}) {
        commit('LOADER', loader)
    }
}
